import { CONTACT_METHOD_TYPES, CONTACT_METHODS } from 'settings/constants/contacts'

const { EMAIL } = CONTACT_METHODS
const { PERSONAL } = CONTACT_METHOD_TYPES

export const INITIAL_STATE = {
  firstName: '',
  lastName: '',
  relationship: '',
  businessName: '',
  propertyOwner: false,
  active: true,
  deactivated: false,
  associatedWithLocation: false,
  beneficialOwnerOverride: false,
  locations: [],
  address: {
    line1: '',
    city: '',
    state: '',
    country: '',
    zipCode: '',
    latitude: '',
    longitude: '',
  },
  contactInfos: [
    {
      type: PERSONAL,
      method: EMAIL,
      data: {
        value: '',
        phoneExtension: '',
      },
    },
  ],
}

export const getAddModel = (initialFirstName, initialLastName, initialMethodValue) => {
  return {
    ...INITIAL_STATE,
    firstName: initialFirstName,
    lastName: initialLastName,
    contactInfos: [{ ...INITIAL_STATE.contactInfos[0], methodValue: initialMethodValue }],
  }
}

export const ADD_EDIT_CONTACT_PARENT_TYPES = {
  ACCOUNTS: 'accounts',
  ACCOUNT_GROUP: 'accountGroup',
  CUSTOMER_DETAILS: 'customerDetails',
}
